module.exports = __webpack_public_path__ + "static/media/comment-dots.ad6a8394.svg";